import React, { useState, useEffect } from 'react';
import {
  Container,
  Paper,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  Alert,
} from '@mui/material';
import {
  Person,
  Email,
  Phone,
} from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';
import { getUserProfile, UserProfile } from '../../services/supabaseService';
import Header from '../../components/Header';

const SettingsPage: React.FC = () => {
  const { currentUser } = useAuth();
  const [profile, setProfile] = useState<UserProfile | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadProfile = async () => {
      try {
        if (currentUser?.uid) {
          const userProfile = await getUserProfile(currentUser.uid);
          setProfile(userProfile);
        }
      } catch (err) {
        console.error('Error loading profile:', err);
      } finally {
        setLoading(false);
      }
    };

    loadProfile();
  }, [currentUser]);

  if (!currentUser) {
    return (
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Alert severity="warning">
          로그인이 필요한 페이지입니다.
        </Alert>
      </Container>
    );
  }

  if (loading) {
    return (
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Box display="flex" justifyContent="center">
          <Typography>로딩 중...</Typography>
        </Box>
      </Container>
    );
  }

  return (
    <>
      <Header showIcons={true} />
      <Container maxWidth="md" sx={{ py: 4, pt: 0 }}>
        <Paper elevation={3} sx={{ p: 4, mt: 2 }}>
          <Typography variant="h4" gutterBottom>
            프로필 정보
          </Typography>

          <Box mb={4}>
            <List>
              <ListItem>
                <ListItemIcon>
                  <Person />
                </ListItemIcon>
                <ListItemText
                  primary="이름"
                  secondary={profile?.displayName || '미설정'}
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <Email />
                </ListItemIcon>
                <ListItemText
                  primary="이메일"
                  secondary={profile?.email || '미설정'}
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <Phone />
                </ListItemIcon>
                <ListItemText
                  primary="전화번호"
                  secondary={profile?.phoneNumber || '미설정'}
                />
              </ListItem>
            </List>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Typography variant="body2" color="text.secondary">
            프로필 수정은 관리자에게 문의해주세요.
          </Typography>
        </Paper>
      </Container>
    </>
  );
};

export default SettingsPage; 